/* eslint no-unused-vars: 1 */

/** the data services not a factory to avoid trouble on moving to Angular 2 */
(function() {
    'use strict';
    angular.module('porting').service('mnpFormProvider', [ '$http', '$injector', function($http, $injector) {
        function portingRequestBasketPut(url, type, value) {
            var data = {
                'PortingRequest': {
                    'msisdn': value
                }
            };
            return $http({
                method: 'PUT',
                url: url,
                data: data
            });
        };
        function portingRequestBasketGet(url) {
            return $http({
                method: 'GET',
                url: url
            });
        };
        function portingRequestCheckoutGet(url) {
            return $http({
                method: 'GET',
                url: url
            });
        };
        function portingRequestCheckoutPut(url, data) {
            return $http({
                method: 'PUT',
                url: url,
                data: data
            });
        };

        function portingRequestOrderPost(url, data) {
            return $http({
                method: 'POST',
                url: url,
                data: data
            });
        };

        function checkIfPortingOrderExistsForPreliminaryNumber(url) {
            return $http({
                method: 'POST',
                url: url,
                data: {}
            });
        };

        function checkIfPortingOrderExistsForNumberToBePorted(url, data) {
            return $http({
                method: 'POST',
                url: url,
                data: data
            });
        };



        function mobileNumberCheck(ndc, number) {
            var deferred = $.Deferred();
            $http({
                method: 'POST',
                url: $injector.get('config').apiURLs.MOBILENUMBERCHECK,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                data: {
                    countryCode: '049',
                    nationalDestinationCode: ndc,
                    subscriberNumber: number
                }
            }).then(function(response){
                if ('undefined' !== typeof response.data && response.data.VALID){
                    deferred.resolve(response.data);
                } else {
                    deferred.reject(response.data);
                }
            });
            return deferred.promise();
        };

        return {
            portingRequestBasketPut: portingRequestBasketPut,
            portingRequestBasketGet: portingRequestBasketGet,
            portingRequestCheckoutGet: portingRequestCheckoutGet,
            portingRequestCheckoutPut: portingRequestCheckoutPut,
            portingRequestOrderPost: portingRequestOrderPost,
            mobileNumberCheck: mobileNumberCheck,
            checkIfPortingOrderExistsForPreliminaryNumber: checkIfPortingOrderExistsForPreliminaryNumber,
            checkIfPortingOrderExistsForNumberToBePorted: checkIfPortingOrderExistsForNumberToBePorted
        };
    }
    ]);

})();
